<template>
  <div>
    <pt-form-item label="是否合格:" labelWidth="90px" :required="true">
      <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否合格">
        <el-radio label="QUALIFIED">合格</el-radio>
        <el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
      </el-radio-group>
    </pt-form-item>
    <div v-if="form.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'">
      <pt-form-item label="原因:" labelWidth="90px" :required="true">
        <el-input name="reason" data-vv-as="原因" v-validate="'required'" type="textarea"
          :autosize="{ minRows: 5, maxRows: 6 }" v-model="form.reason"
          :placeholder="form.result == 'QUALIFIED' ? '选填' : '请填写原因'"></el-input>
      </pt-form-item>
      <pt-form-item label="备注:" labelWidth="90px" >
        <el-input name="comment" data-vv-as="备注" type="textarea"
          :autosize="{ minRows: 5, maxRows: 6 }" v-model="form.comment" placeholder="请填写备注"></el-input>
      </pt-form-item>
    </div>
    <div v-else>
      <pt-form-item label="备注:" labelWidth="90px">
        <el-input name="comment" data-vv-as="备注" type="textarea"
          :autosize="{ minRows: 5, maxRows: 6 }" v-model="form.comment" placeholder="请填写备注"></el-input>
      </pt-form-item>
    </div>
  </div>
</template>
<script>
import {
  validate
} from 'utils/validate'
import {
  AdultNext
} from '../status.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '制备',
      form: {
        result: 'QUALIFIED',
        reason: '',
        expressNum: ''
      },
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      }
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    next () {
      let data = {
        orderIds: [this.order.id],
        action: this.status
      }
      if (this.form.result === 'NOT_QUALIFIED_WAIT_FUTURE_ACTION') {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          reason: this.form.reason,
          comment: this.form.comment
        }
      } else {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          comment: this.form.comment
        }
      }
      return AdultNext.call(this, data)
    }
  },
  created () {

  }

}

</script>

<style lang="less">

</style>
